// extracted by mini-css-extract-plugin
export default {"wrapper":"feedback-response-modal_wrapper__DBNWP","wrapperShort":"feedback-response-modal_wrapperShort__CXsb1","btnReSend":"feedback-response-modal_btnReSend__Q9CKo"};